module.exports = __webpack_public_path__ + "img/zacknite.048a3bae.jpg";